import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["innerHTML"]

import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import axios from '@/plugins/axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenanceView',
  setup(__props) {

const router = useRouter();
const maintenanceInfo = ref<string | null>(null);
const loading = ref(true);

onMounted(async () => {
  const res = await axios.get(process.env.UNDER_MAINTENANCE_URL_ENDPOINT);
  // メンテナンス状態出ない場合はログイン画面へリダイレクト
  if (res.data === 0) {
    await router.push({ name: 'a10' });
  }
  maintenanceInfo.value = res.data;
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", { innerHTML: maintenanceInfo.value }, null, 8, _hoisted_3)
      ]))
}
}

})